module.exports = __webpack_public_path__ + "static/media/edx_logo.91ae2411.svg";